import React, { useState } from "react";
import api from "../services/api";
import toast from "react-hot-toast";

export default function Login({ onLogin }) {
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async e => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/auth/login", form);
      localStorage.setItem("user", JSON.stringify(r.data.user));
      onLogin(r.data.token);
      toast.success("Connexion réussie");
    } catch { toast.error("Identifiants incorrects"); }
    setLoading(false);
  };

  return (
    <div style={{ minHeight: "100vh", background: "linear-gradient(135deg, #1B3A8C 0%, #2a4fa3 100%)", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div style={{ background: "#fff", borderRadius: 16, padding: "40px", width: 400, boxShadow: "0 20px 60px rgba(0,0,0,0.3)" }}>
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <div style={{ background: "#fff", border: "2px solid #f0f0f0", borderRadius: 12, padding: 16, display: "inline-block", marginBottom: 16 }}>
            <img src="/logo.png" alt="OGP" style={{ height: 80, objectFit: "contain" }} onError={e => { e.target.parentElement.innerHTML = '<div style="font-size:32px">🏢</div>'; }} />
          </div>
          <h1 style={{ color: "#1B3A8C", fontSize: 22, fontWeight: 700 }}>Office Guinéen de Publicité</h1>
          <p style={{ color: "#666", fontSize: 14, marginTop: 4 }}>Recensement des Supports</p>
        </div>
        <form onSubmit={submit}>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: "block", fontSize: 13, color: "#555", marginBottom: 6, fontWeight: 600 }}>Email</label>
            <input type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})}
              style={{ width: "100%", padding: "10px 14px", border: "2px solid #e0e0e0", borderRadius: 8, fontSize: 14, outline: "none" }}
              placeholder="admin@ogp.gn" required />
          </div>
          <div style={{ marginBottom: 24 }}>
            <label style={{ display: "block", fontSize: 13, color: "#555", marginBottom: 6, fontWeight: 600 }}>Mot de passe</label>
            <input type="password" value={form.password} onChange={e => setForm({...form, password: e.target.value})}
              style={{ width: "100%", padding: "10px 14px", border: "2px solid #e0e0e0", borderRadius: 8, fontSize: 14, outline: "none" }}
              placeholder="••••••••" required />
          </div>
          <button type="submit" disabled={loading} style={{
            width: "100%", padding: "12px", background: loading ? "#ccc" : "#1B3A8C",
            color: "#fff", border: "none", borderRadius: 8, fontSize: 15, fontWeight: 700, cursor: "pointer"
          }}>{loading ? "Connexion..." : "Se connecter"}</button>
        </form>
      </div>
    </div>
  );
}
